<style scoped>
    .info{
        display: inline-block;
        margin: 0 10px;
        vertical-align: middle;
    }
    .search-input{
        display: inline-block;
        min-width: 250px;
        max-width: 600px;
    }
</style>
<template>
  <div>
    <div
      v-show="topic.name"
      class="line text-center"
    >
      <div class="line">
        <Select
          v-model.number="params.team_id"
          placeholder="团队"
          style="width: 150px"
          @on-change="doSearch"
        >
          <Option :value="0">
            所有团队
          </Option>
          <Option
            v-for="team in teams"
            :key="team.id"
            :value="team.id"
          >
            {{ team.name }}
          </Option>
        </Select>
        <space />
        <div class="search-input">
          <i-input
            v-model="params.search"
            placeholder="请输入搜索关键字"
            @on-enter="doSearch"
          />
        </div>
        <space />
        <Ajaxbtn
          ref="searchBtn"
          :url="get_detail_path"
          :params="{
            ...params,
            flow_finished: select_tab==='1'
          }"
          type="search"
          @before="beforeSearch"
          @done="handleData"
        />
        <space />
        <Button
          @click="exportRecords()"
        >
          导出数据
        </Button>
        <space />
        <Button @click="importClick">
          导入实收/个税数据
        </Button>
        <FileUploader
          v-show="false"
          ref="fileloader"
          style="display: inline-block"
          type="select"
          :data="{topic_id: topic.id}"
          :upload_path="$util.api.import_informal_wage_topic_records_data"
          @done="importRecordDone"
        />
      </div>
      <div class="line">
        <h2>
          {{ topic.wage_month + ' ' + topic.name }}
          <small>({{ topic.wage_start + ' - ' + topic.wage_end }})</small>
        </h2>
      </div>
      <div class="info">
        <div>实习生 在职: {{ intern_info.in_count }}人 本月离职: {{ intern_info.out_count }}人</div>
        <div>兼职/外包 在职: {{ part_time_info.in_count }}人 本月离职: {{ part_time_info.out_count }}人</div>
      </div>

      <Button
        v-show="!isTopicFinished"
        icon="md-refresh"
        @click="getInformalWageTopicDetail()"
      >
        刷新数据
      </Button>
      <space />
      <Button
        v-if="!!fillIn"
        :type="fillIn.type || undefined"
        :loading="updating_status"
        @click="updateTopicStatus(5)"
      >
        {{ fillIn.title }}
      </Button>
      <space v-show="!!fillIn" />
      <Button
        v-if="!!checkIn"
        :type="checkIn.type || undefined"
        :loading="updating_status"
        @click="updateTopicStatus(6)"
      >
        {{ checkIn.title }}
      </Button>
      <space v-show="!!checkIn" />
      <Button
        v-show="isTopicFinished"
        :loading="updating_status"
        @click="updateTopicStatus(1)"
      >
        重新开启
      </Button>
      <space />
      <Button
        @click="showFlowStatus"
      >
        查看流程状态
      </Button>
      <space />
      <Button
        v-if="select_tab==='1'&&topic.status==='paying'"
        @click="finishGo"
      >
        完成
      </Button>
      <space />
    </div>
    <div class="list-container">
      <Tabs 
        v-model="select_tab"
        @on-click="changeTab"
      >
        <TabPane
          label="流程已完成"
          name="1"
        >
          <Table
            ref="selection-table"
            border
            :row-class-name="rowClassName"
            :columns="records_columns_ed"
            :data="records"
            :no-data-text="empty_tip"
            size="small"
            @on-selection-change="selectionChange"
          />
        </TabPane>
        <TabPane
          label="流程进行中"
          name="2"
        >
          <Table
            border
            :row-class-name="rowClassName"
            :columns="records_columns"
            :data="records"
            :no-data-text="empty_tip"
            size="small"
          />
        </TabPane>
      </Tabs>
      <Backdrop v-show="loading" />
    </div>
    <div class="line">
      <span class="color-error">[红色]</span>表示该条工资记录未发放, 已被废弃.
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <RichText
      :url="save_desc_url"
      :params="edit_record"
      :config="rich_text_config"
      :text.sync="edit_record.desc"
    />

    <Modal
      v-model="edit_config.modal"
      :title="edit_record.account"
      width="600"
      :loading="edit_config.loading"
      ok-text="确定"
      @on-ok="editRecordOK"
    >
      <Form ref="formInline">
        <Form
          ref="formCustom"
          :label-width="80"
        >
          <FormItem label="员工姓名">
            <i-input v-model="edit_record.account" />
          </FormItem>
          <FormItem label="银行卡号">
            <i-input v-model="edit_record.cur_bank_number" />
          </FormItem>
          <FormItem label="其他发放">
            <InputNumber
              v-model="edit_record.other_bonus"
            />
          </FormItem>
          <FormItem label="备注">
            <i-input
              v-model="edit_record.desc"
              type="textarea"
            />
          </FormItem>
        </Form>
      </Form>
    </Modal>

    <VModal
      v-model="status_config.modal"
      title="流程状态"
      width="800"
      cancel-text=""
    >
      <Table
        :columns="director_topic_columns"
        :data="director_topics"
        :loading="getting_director_topics"
      />
    </VModal>
    <CloseModal 
      ref="closeModal"
      @success="getInformalWageTopicDetail" 
    />
    <SelectedSxsListModal 
      ref="selectedSxsListModal"
      v-model="show_finished_modal"
      :info="page_info"
      :topic="topic"
      :records_select="records_select_hash"
      @success="getInformalWageTopicDetail"
    />
    <InformalWageDetailModal
      ref="detailModal"
    />
  </div>
</template>
<script route="/fin/informal_wage_topic_detail/:id">
  import VModal from '../../vuetify_custom/v-modal';
  import UserFlowBase from '../components/flow/user_flow_base';
  import FileUploader from '../components/file/uploader';
  import CloseModal from '@/views/fin/components/close_modal.jsx'
  import SelectedSxsListModal from '@/views/fin/components/selected_sxs_list_modal.vue'
  import InformalWageDetailModal from "./informal_wage_detail_modal.vue"
  import {mapGetters} from "vuex";

  export default {
    components: { VModal, UserFlowBase, FileUploader, CloseModal, SelectedSxsListModal, InformalWageDetailModal },
    data() {
      return {
        select_tab: '1',
        get_detail_path: this.$util.api.informal_wage_topic_detail,
        topic: {},
        director_topics: [],
        intern_info: {},
        part_time_info: {},
        records: [],
        page_records: [],
        show_finished_modal: false,
        records_columns: [
          {
            title: '姓名',
            key: 'account',
            fixed: 'left',
            width: 110,
            render: (h, params) => {
              const record = params.row;
              const ret = [record.account]
              if (record.dimission) {
                ret.push(h('span', {
                  style: {
                    color:'red',
                    marginLeft: '5px'
                  }
                }, '[离职发放]'))
              }
              // h('span', {}, [])
              return h('span', {}, ret);
            }
          },
          {
            title: '银行/卡号',
            key: 'name',
            width: 130,
            render: (h, params) => {
              const record = params.row;
              const ret = [
                h('div', record.cur_bank || '未填写'),
                h('div', record.cur_bank_number || '未填写')
              ];
              return h('div', ret);
            }
          },
          {
            title: '团队',
            key: 'team',
            width: 80,
            render: (h, params) => {
              const record = params.row;
              return h('div', record.team.full_name);
            }
          },
          {
            title: '负责人',
            key: 'director',
            width: 60,
            render: (h, params) => {
              const record = params.row;
              return h('div', record.director);
            }
          },
          {
            title: '税前日薪',
            key: 'cur_daily_wage',
            width: 80,
            align: 'right',
            render: (h, params) => {
              const record = params.row;
              if (record.cur_daily_wage) {
                return h('span', '¥ ' + this.$util.formatPrice(record.cur_daily_wage))
              }
              return h('span', '无 ');
            }
          },
          {
            title: '每日餐补',
            key: 'cur_daily_subsidy',
            width: 80,
            align: 'right',
            render: (h, params) => {
              const record = params.row;
              if (record.cur_daily_subsidy) {
                return h('span', '¥ ' + this.$util.formatPrice(record.cur_daily_subsidy))
              }
              return h('span', '无 ');
            }
          },
          {
            title: '计薪天数（远程+现场）',
            key: 'work_days',
            width: 90,
            align: 'right',
            render: (h, params) => {
              return h('span', this.$util.formatPrice(params.row.work_days))
            }
          },
          {
            title: '餐补天数',
            key: 'subsidy_days',
            width: 100,
            align: 'right',
            render: (h, params) => {
              return h('span', this.$util.formatPrice(params.row.subsidy_days))
            }
          },
          // {
          //     title: '计件工资',
          //     key: 'piece_rate_wage',
          //     width: 100,
          //     align: 'right',
          //     render: (h, params)=>{
          //         return h('span', '¥ ' + this.$util.formatPrice(params.row.piece_rate_wage) )
          //     }
          // },
          {
            title: '奖金',
            key: 'bonus',
            width: 100,
            align: 'right',
            render: (h, params) => {
              return h('span', '¥ ' + this.$util.formatPrice(params.row.bonus))
            }
          },
          {
            title: '扣除',
            key: 'deductions',
            align: 'center',
            width: 100,
            render: (h, params) => {
              return h('span', '¥ ' + this.$util.formatPrice(params.row.deductions))
            }
          },
          {
            title: '其他发放',
            key: 'other_bonus',
            align: 'center',
            width: 100,
            render: (h, params) => {
              return h('span', '¥ ' + this.$util.formatPrice(params.row.other_bonus))
            }
          },
          {
            title: '含税工资',
            fixed: 'right',
            align: 'right',
            width: 80,
            render: (h, params) => {
              const record = params.row;
              return h('div', [h('p', {style: {
                                 padding:'0px',
                                 margin: '0px'
                               }}, '¥ ' + this.$util.formatPrice(record.pre_tax_wage)),
                               h('p', {style: {
                                 padding:'0px',
                                 margin: '0px',
                                 color: '#19be6b'
                               }}, record.paid_at && '已发放' || '')
              ]);
            }
          },
          {
            title: '所得税',
            fixed: 'right',
            align: 'right',
            width: 80,
            render: (h, params) => {
              const record = params.row;
              return h('span', '¥ ' + this.$util.formatPrice(record.tax));
            }
          },
          {
            title: '税后工资',
            fixed: 'right',
            align: 'right',
            width: 80,
            render: (h, params) => {
              const record = params.row;
              return h('span', '¥ ' + this.$util.formatPrice(record.total_wage));
            }
          },
          {
            title: '操作',
            fixed: 'right',
            align: 'center',
            width: 155,
            render: (h, params) => {
              const ret = [];
              ret.push([
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.remarkRecord(params.row);
                    }
                  }
                }, '备注'),
                h('span', ' '),
                h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editRecord(params.row);
                    }
                  }
                }, '编辑')
              ]);
              if (params.row.team_change_flag) {
                ret.push(h('span', ' '));
                ret.push(h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.showDetail(params.row);
                    }
                  }
                }, '明细'))
              }
              if (params.row.status === 7) {
                ret.push(h('span', ' '));
                ret.push(h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.recoverRecord(params.row);
                    }
                  }
                }, '恢复'))
              } else {
                ret.push(h('span', ' '));
                ret.push(h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.abandonRecord(params.row);
                    }
                  }
                }, '废弃'))
              }
              return h('div', ret);
            }
          },
        ],
        director_topic_columns: [
          {
            title: '申请人',
            align: 'center',
            render: (h, params) => {
              const director = params.row.director;
              return h('CustomerPoptip', {
                props: { customer_id: director.id }
              }, director.account);
            }
          },
          {
            title: '月份',
            align: 'center',
            render: (h, params) => {
              const topic = params.row.topic;
              return h('span', topic.wage_month);
            }
          },
          {
            title: '工资总额',
            align: 'right',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.total_wage));
            }
          },
          {
            title: '含税总额',
            align: 'right',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.pre_tax_wage));
            }
          },
          {
            title: '状态',
            align: 'center',
            render: (h, params) => {
              const user_flow = params.row.user_flow;
              if (user_flow) {
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: params.row,
                    // 完成后5天内可以驳回
                    secondsAllowedToFailAfterFinished: 5 * 24 * 3600
                  }
                });
              }
              return h('span', '已完成');
            }
          },
          {
            title: '操作',
            align: 'center',
            width: 400,
            render: (h, params) => {
              const user_flow = params.row.user_flow;
              console.log('user_flow', user_flow)
              if (user_flow && !user_flow.is_finish) {
                return h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click:() => {
                      // 确认给审核人发送审核提醒？
                      // 确认给申请人发送填写提醒？
                      this.$vModal.confirm({
                        title: '提示',
                        content: '确认发送提醒？',
                        loading: true,
                        onOk:({
                          destroy,
                          stopLoading
                        }) => {
                          this.$http.post(Util.api.director_informal_wage_topic_send_notice, {
                            id:params.row.id
                          }).then(() => {
                            this.$Message.success('提醒成功！')
                            destroy()
                            this.getDirectorTopicStatus()
                          }).catch(() => {
                            stopLoading()
                          })
                        }   
                      })
                    }
                  }
                }, '推送提醒');
              }
              return h('span', '');
            }
          }
        ],
        updating_status: false,
        getting_director_topics: false,
        loading: false,
        empty_tip: '获取数据中...',
        params: {
          id: this.$route.params.id,
          per_page: 20,
          page: 1,
          search: '',
          team_id: 0,
        },
        page_info:{
          current: 1,
          total: 0,
          page_size: 20
        },
        rich_text_config: {
          show: false
        },
        save_desc_url: this.$util.api.informal_wage_record_update_desc,
        edit_record: {},
        edit_config: {
          modal: false,
          loading: true
        },
        status_config: {modal: false},
        records_select_hash: {},
      }
    },
    computed: {
      records_select_list() {
            
        if (this.is_finished) {
          const arr = Object.values(this.records_select_hash).filter(item => !!item)
          if (arr.length) {
            return arr
          }
        }
        return null
      },
      records_columns_ed() {
        const arr = []
        if (this.show_finished_modal) {
          arr.push({
            type: 'selection',
            width: 50,
            align: 'center',
            fixed: 'left',
          })
        }
        return arr.concat(this.records_columns)
      },
      is_finished() {
        return this.topic.status === 'finished'
      },
      fillIn() {
        if (this.topic && ['opening', 'auditing'].includes(this.topic.status)) {
          return {
            title: this.topic.status === 'opening' ? '关闭填写通道' : '打开填写通道', 
            type:  this.topic.status === 'opening' ? '' : 'primary', 
                  
          }
        }
        return null
      },
      checkIn() {
        if (this.topic && ['paying', 'auditing'].includes(this.topic.status)) {
          return {
            title: this.topic.status === 'paying' ? '开启审核通道' : '关闭审核通道',  
            type:  this.topic.status === 'paying' ? 'primary' : '', 
                
          }
        }
        return null
      },
      isTopicFinished() {
        return this.topic.status === 5;
      },
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        jobs: 'async/jobs',
        jobs_hash: 'async/jobs_hash',
        offices: 'async/offices',
        offices_hash: 'async/offices_hash',
      })
    },
    created() {
    
      this.getInformalWageTopicDetail();
    },
    methods: {
      showDetail(row) {
        this.$refs.detailModal.edit(row.id)
      },
      importClick() {
        this.$vModal.confirm({
          title: '提示',
          content: '提交之后，将直接进入CBS发薪环节，请再次确认是否要提交?',
          onOk:() => {
       
            this.$refs.fileloader.
              $refs.uploader.
              $refs.input.click()
          }
        })
      },
      upadteNotified(data) {
        if (!data) {
          const tableData = this.$refs['selection-table'].objData
          Object.keys(tableData).forEach(key => {
            const item = tableData[key]
            item._isChecked = !!this.records_select_hash[item.id]
          })
        } else {
          const tableData = this.$refs['selection-table'].objData
          Object.keys(tableData).forEach(key => {
            const item = tableData[key]
            if (item._isChecked) {
              if (!this.records_select_hash[item.id]) {
                this.records_select_hash[item.id] = true
              }
            } else {
              this.records_select_hash[item.id] = false
            }
                      
          })
        } 
      },
      finishGo() {
        this.show_finished_modal = true
        this.$http.get(Util.api.informal_wage_topic_update_status_confirm, {
          id:this.topic.id,
          status: 'finished'
        }).then((data) => {
          this.records_select_hash = data.records.reduce((total, item) => {
            total[item.id] = item
            return total
          }, {})
          console.log('this.records_select_hash', this.records_select_hash)
          this.$nextTick(() => {
            this.upadteNotified()
          })
        })
      },
      // records_select_hash
      selectionChange(res) {
        this.upadteNotified(res)
      },
      changeTab() {
        this.$nextTick(() => {
          this.getInformalWageTopicDetail()
        })
      },
      getInformalWageTopicDetail() {
        if (!this.loading) {
          this.loading = true;
          this.empty_tip = '获取数据中...';
          this.$util.ajax.get(this.get_detail_path, {
            params:{
              ...this.params,
              flow_finished: this.select_tab === '1'
            }
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              const data = res.data;
              this.handleData(data);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.handleFail(e);
          });
        }
      },
      rowClassName(row) {
        // 废弃
        if (row.status === 7) {
          return 'color-error';
        }
        return '';
      },
      doSearch() {
        this.$nextTick(() => {
          this.$refs.searchBtn.doAjax();
        })
      },
      beforeSearch() {
        this.params.page = 1;
        this.loading = true;
        this.empty_tip = '搜索结果中...';
        this.records = [];
      },
      handleData(data) {
        this.loading = false;
        this.topic = data.topic;
        this.intern_info = data.intern_info;
        this.part_time_info = data.part_time_info;
        this.records = [];
        // 按团队排序
        /*let records = data.records.sort((a,b)=>{
                    return a.team_id > b.team_id;
                });*/
        const records = data.records;
        records.forEach((record) => {
          this.records.push(record);
        });
        if (!records.length) {
          this.empty_tip = '暂无数据';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
        if (this.show_finished_modal) {
          this.$nextTick(() => {
            this.upadteNotified()
          })
        }
      },
      handleFail(e) {
        this.loading = false;
        this.empty_tip = '获取数据失败, 请重试';
        console.log(e);
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.getInformalWageTopicDetail();
      },
      commonModal({
        content,
        status
      }) {
        const _this = this
        this.$vModal.confirm({
          title: '提示',
          content,
          loading:true,
          onOk({ stopLoading, destroy }) {
            _this.$http.post(Util.api.update_informal_wage_topic_status, {
              id: _this.topic.id,
              status
            }).then(() => {
              _this.$Message.success({
                content: '打开成功!'
              });
              _this.getInformalWageTopicDetail()
              destroy()
            }).catch(() => {
              stopLoading()
            })
          }
        })
      },
      updateTopicStatus(status) {
        switch (status) {
        case 5:
          if (this.topic.status === 'auditing') {
            this.commonModal({
              content: '确认打开填写通道？',
              status: 'opening'
            })
          } else {
            this.$refs.closeModal.show(status, this.topic)
          }
          break
        case 6:
          if (this.topic.status === 'paying') {
            this.commonModal({
              content: '确认打开审核通道？',
              status: 'auditing'
            })
          } else {
            this.$refs.closeModal.show(status, this.topic)
          }
        
          break;
        default:
          this.$Modal.confirm({
            title: '提示',
            content: '你确定要执行此操作?',
            onOk: () => {
              this.updating_status = true;
              this.$util.ajax.post(this.$util.api.update_informal_wage_topic_status, {
                id: this.topic.id,
                status: status
              }).then((response) => {
                return response.data;
              }).then((data) => {
                if (data.code === 1) {
                  this.topic.status = status;
                  this.$Message.success('操作成功');
                } else {
                  let err_msg = '';
                  data.unfinish_directors && data.unfinish_directors.forEach((director) => {
                    err_msg += (director + ', ');
                  });
                  err_msg = err_msg.slice(0, -2);
                  setTimeout(() => {
                    if (err_msg) {
                      this.$Modal.error({title: data.msg, content: err_msg})
                    } else {
                      this.$Modal.error({title: '提示', content: data.msg})
                    }
                  }, 600);
                }
              }).catch((e) => {
                setTimeout(() => {
                  this.$Modal.error({title: '提示', content: e.message})
                }, 600);
              }).finally(() => {
                this.updating_status = false;
              });
            }
          });
     
          break;
        }
      },
      remarkRecord(record) {
        this.edit_record = record;
        this.rich_text_config.show = true;
      },
      updateRecordDesc() {
        if (this.edit_record.desc === '<p><br></p>') {
          return;
        }
        this.$util.ajax.post(this.$util.api.informal_wage_record_update_desc, this.edit_record).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            // const data = res.data;
            this.$Message.success('操作成功!');
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      editRecord(record) {
        this.edit_record = this.$util.clone(record);
        console.log(record)
        this.edit_config.modal = true;
      },
      editRecordOK() {
        if (!this.$util.LuhnCheck(this.edit_record.cur_bank_number)) {
          this.edit_record.account = this.edit_record.account.trim();
          this.$Modal.confirm({
            title: '提示',
            content: '银行卡号可能有误, 你确定要继续执行吗?',
            okText: '取消',
            cancelText: '继续修改',
            onOk: () => {
              this.edit_config.loading = false;
              setTimeout(() => {
                this.edit_config.loading = true;
              }, 500);
            },
            onCancel: () => {
              // 故意交换ok和cancel的位置, 让取消更显眼
              this.updateRecord();
            }
          })
        } else {
          this.updateRecord();
        }
      },
      updateRecord() {
        this.$util.ajax.post(this.$util.api.update_informal_wage, this.edit_record).then((response) => {
          return response.data;
        }).then((data) => {
          console.log(data);
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 500);
          if (data.code === 1) {
            this.edit_config.modal = false;
            this.$Message.success('更新信息成功!');
            this.$util.insertOrUpdateArrayItem(this.records, data.record);
          } else {
            this.$Message.error(data.msg);
          }
        }).catch((e) => {
          console.log(e);
          this.edit_config.loading = false;
          setTimeout(() => {
            this.edit_config.loading = true;
          }, 500);
          this.$Message.error('更新信息失败:' + e);
        });
      },
      abandonRecord(record) {
        let msg = '<p>你确定要废弃此条记录吗?</p>';
        msg += '<p>废弃后会向当事人和负责人发送通知信息.</p>';
        msg += '<p>如有必要, 请备注废弃原因, 以备后续查阅.</p>';
        this.$Modal.confirm({
          title: '提示',
          content: msg,
          onOk: () => {
            this.$util.ajax.post(this.$util.api.abandon_informal_wage, {
              id: record.id
            }).then((response) => {
              return response.data;
            }).then((data) => {
              console.log(data);
              if (data.code === 1) {
                this.$Message.success('废弃成功!');
                this.$util.insertOrUpdateArrayItem(this.records, data.record);
              } else {
                this.$Modal.error({title: '操作失败', content: data.msg});
              }
            }).catch((e) => {
              console.log(e);
              this.$Modal.error({title: '操作失败', content: '更新信息失败:' + e});
            });
          }
        })
      },
      recoverRecord(record) {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>你确定要恢复此条记录吗?</p>',
          onOk: () => {
            this.$util.ajax.post(this.$util.api.recover_informal_wage, {
              id: record.id
            }).then((response) => {
              return response.data;
            }).then((data) => {
              console.log(data);
              if (data.code === 1) {
                this.$Message.success('恢复成功!');
                this.$util.insertOrUpdateArrayItem(this.records, data.record);
              } else {
                this.$Modal.error({title: '操作失败', content: data.msg});
              }
            }).catch((e) => {
              console.log(e);
              this.$Modal.error({title: '操作失败', content: '更新信息失败:' + e});
            });
          }
        })
      },
      showFlowStatus() {
        this.status_config.modal = true;
        this.getDirectorTopicStatus();
      },
      getDirectorTopicStatus() {
        this.getting_director_topics = true;
        this.$util.ajax.get(this.$util.api.informal_wage_topic_director_topics, {
          params: {id: this.topic.id}
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.director_topics = res.data.director_topics;
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.error({title: '错误', content: e.message});
        }).finally(() => {
          this.getting_director_topics = false;
        });
      },
      exportRecords() {
        if (this.topic.id) {
          window.open(this.$util.api.export_informal_wage_topic_records_data + `?id=${this.topic.id}&flow_finished=${this.select_tab === '1'}`, '_blank');
        } else {
          this.$Message.error('信息有误, 不能导出');
        }
      },
      importRecordDone() {
        this.doSearch();
        this.$Modal.success({title: '提示', content: '上传成功'});
      }
    }
  }
</script>
